// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
export async function postJson(u, o, m) {
  const r = await fetch(u, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(o),
    signal: m
  });
  if (!r.ok) throw new Error(`${u}: ${r.status}`);
  return r.json();
}
